import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';

@Component({
    selector: 'app-buy-car-box-list',
    templateUrl: './buy-car-box-list.component.html',
    styleUrls: ['./buy-car-box-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuyCarBoxListComponent {

  businessLine: CarBusinessLine = CarBusinessLine.BUY; 

}
